// src/components/InstagramConnect.tsx

import { useState } from 'react';

const META_APP_ID = (import.meta as any).env.VITE_META_APP_ID || '';

export function InstagramConnect() {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = () => {
    setConnecting(true);

    const state = generateRandomState();
    localStorage.setItem('instagram_oauth_state', state);

    const params = new URLSearchParams({
      client_id: META_APP_ID,
      redirect_uri: `${window.location.origin}/instagram-callback`,
      scope: 'instagram_manage_messages,instagram_manage_insights,pages_show_list,pages_messaging',
      response_type: 'code',
      state: state,
    });

    window.location.href = `https://www.facebook.com/v18.0/dialog/oauth?${params}`;
  };

  return (
    <div className="flex flex-col items-center p-6 border rounded-lg bg-white shadow-sm">
      <h2 className="text-lg font-semibold mb-4">Connect Your Instagram Business Account</h2>
      <div className="text-sm text-gray-600 mb-6 text-center space-y-2">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <h4 className="font-semibold text-blue-800 mb-2">⚠️ Facebook Login Required</h4>
          <p className="text-blue-700 text-sm mb-2">
            Instagram Business messaging requires Facebook Login authentication.
            You'll be redirected to Facebook to authorize the connection.
          </p>
          <div className="text-left text-xs text-blue-600 space-y-1">
            <p><strong>What happens next:</strong></p>
            <ol className="list-decimal list-inside ml-2 space-y-1">
              <li>Click "Connect Instagram" below</li>
              <li>Login to Facebook if prompted</li>
              <li>Select your Facebook Page connected to Instagram</li>
              <li>Grant permissions for Instagram messaging</li>
              <li>You'll be redirected back to complete setup</li>
            </ol>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
          <h4 className="font-semibold text-yellow-800 mb-2">📋 Prerequisites</h4>
          <div className="text-left text-xs text-yellow-700 space-y-1">
            <p><strong>You need:</strong></p>
            <ol className="list-decimal list-inside ml-2 space-y-1">
              <li>Instagram Business or Creator Account</li>
              <li>Facebook Page connected to your Instagram account</li>
              <li>Admin access to the Facebook Page</li>
            </ol>
          </div>
        </div>

        <p className="font-medium">Business Account Benefits:</p>
        <ul className="list-disc list-inside space-y-1 text-left">
          <li>Automated DM responses with AI</li>
          <li>24-hour messaging window (reply to users who message you)</li>
          <li>Webhook notifications for new messages</li>
          <li>Official Meta Graph API integration</li>
        </ul>
      </div>
      <button
        onClick={handleConnect}
        disabled={connecting || !META_APP_ID}
        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {connecting ? 'Connecting...' : 'Connect Instagram'}
      </button>
      {!META_APP_ID && (
        <p className="text-xs text-red-500 mt-2">Meta App ID not configured</p>
      )}
    </div>
  );
}

function generateRandomState(): string {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15);
}
